import $ from "jquery"
import _ from "underscore"
import PDFSettingsPreview from "../../../pdfSettingsPreview/PDFSettingsPreview";
import SignatureSettingsSection from "./SignatureSettingsSection"

class ViewTTPagePDFSettingsPreview extends PDFSettingsPreview {
    constructor($containerEl, lightboxId)
    {
        super($containerEl, lightboxId);
    }

    afterRender()
    {
        super.afterRender();

        $(document.getElementById(this.lightboxId + "_numberOfPages")).hide();
        
        var self = this;
        this.signatureSettingsSection = new SignatureSettingsSection(
                this.getCustomSettingsSectionContainer(),
                this.lightboxId
        ).init();
        $(this.signatureSettingsSection).on("change", function()
        {
            self.handleParameterChange();
        });
    }

    update()
    {
        super.update();
        this.signatureSettingsSection.update();
    }

    subscribeToEvents()
    {
        super.subscribeToEvents();

        var self = this;
        $(document).on("viewTT.pdfPreview.lightbox.show", function()
        {
            self.update();
            var printParametersForGenerate = self.collectPrintParametersForGenerate();
            self.triggerIntermediatePrintParametersChange(printParametersForGenerate);
            self.triggerPrintParametersForGenerateChange(printParametersForGenerate);
        })
    }

    unsubscribeFromEvents()
    {
        super.unsubscribeFromEvents();
        $(document).off("viewTT.pdfPreview.lightbox.show");
    }

    getStore()
    {
        return ViewTTStore;
    }

    updateNumberOfPagesInformation()
    {
        // do nothing
    }

    triggerIntermediatePrintParametersChange(newPrintParameters)
    {
        $(document).trigger("viewTT.pdfPreview.intermediatePrintParametersChange", newPrintParameters);
    }

    triggerPrintParametersForSaveChange(printParametersForSave)
    {
        $(document).trigger("viewTT.pdfPreview.printParametersForSaveChange", printParametersForSave);
    }

    triggerPrintParametersForGenerateChange(printParametersForGenerate)
    {
        $(document).trigger("viewTT.pdfPreview.printParametersForGenerateChange", printParametersForGenerate);
    }

    collectPrintParametersForGenerate()
    {
        var printParametersForGenerate = super.collectPrintParametersForGenerate();
        return _.extend(printParametersForGenerate, this.signatureSettingsSection.collectPrintParameters());
    }

    collectPrintParametersForSave()
    {
        return this.collectPrintParametersForGenerate();
    }
}

export default ViewTTPagePDFSettingsPreview


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdfSettingsPreview/PDFSettingsPreview.js